






























































































































































































































import { CommentState, CommentType, DirectedAt } from "@/enums";
import Vue from "vue";
import CommentReplyCard from "./CommentReplyCard.vue";
import CommentIcon from "./CommentIcon.vue";
import EditCommentCard from "./EditCommentCard.vue";
import storeHelper from "@/store/store-helper";
import { DocumentAnchor } from "node_modules/@infoland/iprova-api/lib/types";
import { Comment } from "@/documentComments";
import RejectCommentReason from "./RejectCommentReason.vue";
import ZenyaDialog from "../../../dialogs/ZenyaDialog.vue";
import { SnackBarTimeout } from "@/enums";
import { PendingCommentEdit } from "@/types/document/pendingDocumentComments";
import { CommentReply } from "@/types/commentReply";

export default Vue.extend({
    name: "DocumentCommentCard",
    props: {
        comment: Object as () => Comment,
        commentSubjectSelections: { type: Array as () => DocumentAnchor[] },
        commentStateEditable: Boolean,
        userIsDocumentAdministrator: Boolean,
        userIsDocumentWriter: Boolean,
        canDeleteComment: Boolean,
        isReviewDocument: Boolean
    },
    components: { CommentReplyCard, CommentIcon, EditCommentCard, RejectCommentReason, ZenyaDialog },
    data: function () {
        return {
            showCommentReply: false,
            commentReply: "",
            shouldEditComment: false,
            directedAt: { ...DirectedAt },
            showRejectCommentDialog: false,
            commentStates: { ...CommentState }
        };
    },
    computed: {
        pendingCommentEdit(): PendingCommentEdit {
            return {
                document: this.comment.document,
                commentID: this.comment.comment_id,
                isValid: true,
                commentText: this.commentText,
                anchor_id: this.comment.anchor_id,
                anchor_text: this.comment.anchor_text,
                anchor_type: this.comment.anchor_type
            };
        },
        documentHasAnchors(): boolean {
            return this.commentSubjectSelections?.length > 1;
        },
        commentText(): string {
            return this.documentHasAnchors
                ? this.comment.text
                : this.comment.anchor_text && this.comment.anchor_text.length > 1
                ? this.comment.anchor_text + " - " + this.comment.text
                : this.comment.text;
        },
        commentStateLabel(): string {
            if (this.comment.state) {
                return (this.$t("comment.state." + this.comment.state) as string).toUpperCase();
            }
            return "";
        },
        isCommentDeleted(): boolean {
            return this.comment.deleted;
        },
        shouldDisplayEditBtn(): boolean {
            return this.comment.creator_id === this.$user.user_id;
        },
        isSoftDelete(): boolean {
            return !this.isCommentDeleted && this.canDeleteComment;
        },
        smAndDown(): boolean {
            return this.$vuetify.breakpoint.smAndDown;
        },
        replyButtonVisible(): boolean {
            return !this.isCommentDeleted && (this.isReviewDocument || this.userIsDocumentWriter || this.userIsDocumentAdministrator);
        },
        replyCommenterCommentType(): CommentType {
            if (this.isReviewDocument) {
                return CommentType.Reviewer;
            }
            if (this.userIsDocumentWriter || this.userIsDocumentAdministrator) {
                return CommentType.Writer;
            }
            return CommentType.Reader;
        }
    },
    watch: {
        showRejectCommentDialog: function (newValue: boolean) {
            this.$emit("reject-comment", newValue);
        }
    },
    methods: {
        toggleOnReply(): void {
            this.showCommentReply = !this.showCommentReply;

            if (this.isReviewDocument) {
                //only in review we want to keep track of pending changes
                if (this.showCommentReply)
                    storeHelper.pendingDocumentCommentStore.addUpdateNewReplies({
                        replyText: "",
                        document: this.comment.document,
                        commentID: this.comment.comment_id,
                        isValid: false,
                        commentType: this.replyCommenterCommentType
                    });
                else storeHelper.pendingDocumentCommentStore.removeNewReplies(this.comment.comment_id);
            }
        },
        toggleOnEditReply(reply: CommentReply): void {
            if (this.isReviewDocument) {
                //only in review we want to keep track of pending changes
                //if we are currently editing then we wont be after toggle, so remove from pending changes.
                //if we are not editing then we will be, so add to pending changes.
                if (reply.editing) storeHelper.pendingDocumentCommentStore.removeReplyEdits(reply.comment_reply_id);
                else
                    storeHelper.pendingDocumentCommentStore.addUpdateReplyEdits({
                        replyID: reply.comment_reply_id,
                        replyText: reply.text,
                        document: this.comment.document,
                        commentID: this.comment.comment_id,
                        isValid: true
                    });
            }

            storeHelper.documentStore.toggleCommentReply(this.comment.comment_id, reply.comment_reply_id);
        },
        async onDelete(comment_id: number): Promise<void> {
            const result = await storeHelper.documentStore.deleteCommentAsync(comment_id);

            if (this.isReviewDocument) {
                //only in review we want to keep track of pending changes
                storeHelper.pendingDocumentCommentStore.removeNewReplies(comment_id);
                storeHelper.pendingDocumentCommentStore.removeReplyEditsForComment(comment_id);
            }

            if (!result.success) {
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error"), true);
            }
        },
        async onUndelete(comment_id: number): Promise<void> {
            const result = await storeHelper.documentStore.undeleteCommentAsync(comment_id);
            if (!result.success) {
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error"), true);
            }
        },
        toggleOnEdit(): void {
            this.shouldEditComment = !this.shouldEditComment;
            if (this.isReviewDocument) {
                //only in review we want to keep track of pending changes
                if (this.shouldEditComment) storeHelper.pendingDocumentCommentStore.addUpdateCommentEdit(this.pendingCommentEdit);
                else storeHelper.pendingDocumentCommentStore.removeCommentEdit(this.comment.comment_id);
            }
        },
        async onStateChange(newState: CommentState): Promise<void> {
            if (newState == CommentState.Rejected) {
                this.showRejectCommentDialog = true;
            } else {
                const result = await storeHelper.documentStore.updateDocumentCommentState(newState, this.comment.comment_id);
                this.showSnackbar(result.success);
            }
        },
        showSnackbar(successful: boolean): void {
            if (successful) {
                storeHelper.siteStore.setSnackBarMessage(this.$t("comment.changedStateSuccessfullyMessage"), false, SnackBarTimeout.short);
            } else {
                storeHelper.siteStore.setSnackBarMessage(this.$t("general.messages.error"), true);
            }
        },
        getStateColor(state): string {
            switch (state) {
                case CommentState.Fixed:
                    return "materialGreen";
                case CommentState.Rejected:
                    return "materialRed";
                case CommentState.Accepted:
                    return "materialBlue";
                default:
                    return "materialGrey";
            }
        },
        getLabelColor(): string {
            if (this.comment.state === CommentState.Fixed) {
                return "#388e3c";
            } else if (this.comment.state === CommentState.Rejected) {
                return "#d32f2f";
            } else if (this.comment.state === CommentState.Accepted) {
                return "#303F9F";
            }
            return "#616161";
        },
        getStateText(state): string {
            switch (state) {
                case CommentState.Fixed:
                    return this.$t("comment.state.fixed").toString();
                case CommentState.Rejected:
                    return this.$t("comment.state.rejected").toString();
                case CommentState.Accepted:
                    return this.$t("comment.state.accepted").toString();
                default:
                    return this.$t("comment.state.new").toString();
            }
        }
    }
});
